export enum LoanPurpose {
    PURCHASE = 'PURCHASE',
    REFINANCE = 'REFINANCE',
    REFINANCE_RATE_TERM = 'REFINANCE_RATE_TERM',
    REFINANCE_CASH_OUT = 'REFINANCE_CASH_OUT'
}

export const loanPurposeDisplay = {
    [LoanPurpose.PURCHASE]: 'Purchase',
    [LoanPurpose.REFINANCE]: 'Refinance',
    [LoanPurpose.REFINANCE_RATE_TERM]: 'Rate-term Refi',
    [LoanPurpose.REFINANCE_CASH_OUT]: 'Cash-out Refi'
};
